export default (res) => {
  const { data, status, statusText } = res

  return {
    ...data,
    status,
    statusText,
  }
}
